
import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyStateProps {
  message: string;
  description: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, description }) => {
  return (
    <Card className="border border-border/20 bg-background hover:bg-background/80 transition-colors">
      <CardContent className="flex flex-col items-center justify-center p-12">
        <div className="w-16 h-16 rounded-full bg-background flex items-center justify-center mb-4 border border-border/20">
          <HelpCircle className="h-8 w-8 text-muted-foreground" />
        </div>
        <h3 className="text-xl font-medium mb-2">{message}</h3>
        <p className="text-center text-muted-foreground max-w-sm">
          {description}
        </p>
      </CardContent>
    </Card>
  );
};

export default EmptyState;
